import { saveUserSettings, userSettings } from "@/globals/userSettings";
import runAccessibility from "./runAccessibility";
import { updateWidgetResetButton } from "../widget/widget";

export default function reset() {
    document?.querySelectorAll(".asw-selected")?.forEach(el => el?.classList?.remove("asw-selected"))
    window.dispatchEvent(new CustomEvent('sienna:close-screen-reader'));

    userSettings.states = {};
    runAccessibility();

    const $amount = document.querySelector(".asw-amount");
    if ($amount) $amount.textContent = "100%";

    saveUserSettings();
    updateWidgetResetButton();
}
